const footerText = {
  description: "Movies is top of free streaming website, where to watch movies online free without registration required. With a big database and great features, we're confident FMovies is the best free movies online website in the space that you can't simply miss!",
  twitter: 'Connect with us on GitHub',
  disclaimer: 'This site does not store any files on our server, we only linked to the media which is hosted on 3rd party services.',
  links: [
    ['Movies', 'TV-Shows', 'Most Watched', 'Top IMDb'],
    ['Action Movies', 'Horror Movies', 'Sci-fi Movies', 'Thriller Movies', 'gogoanime'],
    ['Contact', 'Request'],
  ],
};

export default footerText;
